export default __webpack_public_path__ + "static/media/appointment.2448d063.jpg";